import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const imvCheckListApi = createApi({
  baseQuery,
  reducerPath: 'imvCheckListApi',
  endpoints: builder => ({
    getimvChecklistData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application, monitoring_visit_id }) => ({
        url: `${formatString(
          endPoints.ImvChecklist.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&monitoring_visit_id=${monitoring_visit_id}
          `,
        method: 'GET'
      })
    }),

    createImvChecklistData: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(
          endPoints.ImvChecklist.create,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}&application_section=CONDUCT&application_module_section=IMV%20CHECKLIST`,
        method: 'POST',
        body: data
      })
    }),

    updateImvChecklistData: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application }) => ({
        url: `${formatString(
          endPoints.ImvChecklist.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      })
    }),
    getAllImvChecklistData: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, application, from = -1, size = -1 }) => {
        return {
          url: `${formatString(
            endPoints.ImvChecklist.getAll
          )}?study_id=${study_id}&site_id=${site_id}&country=${country}&application=${application}${
            from > -1 ? `&from=${from}` : ''
          }${size > -1 ? `&size=${size}` : ''}`,
          method: 'POST',
          body: data
        };
      }
    }),
    uploadDocument: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(
          endPoints.ImvChecklist.upload
        )}?application=CTMS&application_section=CONDUCT&application_module_section=IMV%20CHECKLIST`,
        method: 'POST',
        body: data
      })
    }),

    publishImvChecklistData: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        data,
        publish_doc_version,
        monitoring_visit_id,
        update,
        application,
        is_published
      }) => ({
        url: `${formatString(
          endPoints.ImvChecklist.publish,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&publish_doc_version=${publish_doc_version}&monitoring_visit_id=${monitoring_visit_id}&update=${update}&application=${application}&is_published=${is_published}&application_section=CONDUCT&application_module_section=IMV%20CHECKLIST`,
        method: 'POST',
        body: data
      })
    })
  })
});

export const {
  useGetimvChecklistDataQuery,
  useUpdateImvChecklistDataMutation,
  useCreateImvChecklistDataMutation,
  useGetAllImvChecklistDataMutation,
  useUploadDocumentMutation,
  usePublishImvChecklistDataMutation
} = imvCheckListApi;
